<template>
  <div
    v-update-position
    class="text-image-parallax">
      <div class="text-image-parallax__titles">
        <h5 class="-first-line">{{ title }}</h5>
        <h5 class="-second-line">{{ title2 }}</h5>
        <h5 class="-third-line">{{ title3 }}</h5>
      </div>
      <div class="text-image-parallax__image">
        <img :src="image">
        <router-link
          v-if="!loading"
          :to="link"
          class="glaxi__link"
          style="padding: .7rem 1.7rem">
            {{ textButton }}
        </router-link>
        <h5 class="-first-line">{{ title }}</h5>
        <h5 class="-second-line">{{ title2 }}</h5>
        <h5 class="-third-line">{{ title3 }}</h5>
      </div>
  </div>
</template>

<script>

import { TweenLite } from 'gsap/TweenLite'
import { TweenMax } from 'gsap/TweenMax'

import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'TextImageParallax',
  mixins: [matchMedia],
  data: () => ({
    scrollY: undefined
  }),
  computed: {
    timeDivider: {
      get () {
        if (this.matchMedia === 'small') return 10
        if (this.matchMedia === 'medium') return 7
        return 5
      }
    }
  },
  props: {
    title: {
      type: String,
      required: false
    },
    title2: {
      type: String,
      required: false
    },
    title3: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    textButton: {
      type: String,
      required: false
    },
    link: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    $_observeScroll (el) {
      this.scrollY = el.getBoundingClientRect().top

      const row1 = el.querySelectorAll('.-first-line')
      const row2 = el.querySelectorAll('.-second-line')
      const row3 = el.querySelectorAll('.-third-line')

      row1.forEach((element, currentIndex, listObj) => {
        TweenLite.to(element, 0.6, { x: -this.scrollY / this.timeDivider })
      })
      row2.forEach((element, currentIndex, listObj) => {
        TweenLite.to(element, 0.6, { x: this.scrollY / this.timeDivider })
      })
      row3.forEach((element, currentIndex, listObj) => {
        TweenLite.to(element, 0.6, { x: -this.scrollY / this.timeDivider })
      })
    }
  },
  directives: {
    'update-position': {
      bind (el, binding, vnode) {
        window.addEventListener('scroll', vnode.context.$_observeScroll.bind(vnode.context, el))
      },
      unbind (el, binding, vnode) {
        window.removeEventListener('scroll', vnode.context.$_observeScroll.bind(vnode.context, el))
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./component.scss";
</style>
